<template>
    <v-alert v-if="props.show" type="success" class="mt-3">
        {{ message }}
    </v-alert>
</template>
<script setup lang="ts">
    export interface Props {
        show: boolean
        message: string
    }

    const props = withDefaults(defineProps<Props>(), {})
</script>
